import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_q75daxcrsn: FaireBrandEntity = {
  token: "b_q75daxcrsn",
  type: "brand",
  name: "ThatsRad",
  avatarUrl:
    "https://cdn.faire.com/fastly/083544deb0bd85faeaa159141231760d470d54863e8745c8a9164de46818207e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1eb923a66e3d00ca78db55a7c1dc33b56fc5aa26ff81b326de17b640084849d5.png",
  logoUrl:
    "https://cdn.faire.com/fastly/083544deb0bd85faeaa159141231760d470d54863e8745c8a9164de46818207e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1eb923a66e3d00ca78db55a7c1dc33b56fc5aa26ff81b326de17b640084849d5.png",
  location: "Berlin, MD, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 18,
  isTopShop: true,
  isInsider: true,
  description: "Selling online since 1999. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:21.711Z",
    importedBy: "entity-db-cli",
  },
};
